
export default {
    CHARACTER: 'Character',
    IMAGE: 'Image',
    BACKGROUND: 'Background',
    RECTANGLE:  'Rectangle',
    ELLIPSE:  'Ellipse',
    LINE: 'Line',
    CURVE: 'Curve',
    FREEHAND: 'Freehand',
    AUDIO: 'Audio',
    TEXTBOX: 'TextBox',
    TEXTBOXSIMPLE: 'TextBoxSimple',
    SPEAK_BUBBLE: 'SpeakBubble',
    COMPLEX_SPEAK_BUBBLE: 'ComplexSpeakBubble',
    THOUGHT_BUBBLE: 'ThoughtBubble',
    SCREAM_BUBBLE: 'ScreamBubble',
    TRIANGLE: 'Triangle',
    STAR: 'Star',
    HEART: 'Heart',
    VIDEO: 'Video',
    GROUP: 'Group'
};



/** WEBPACK FOOTER **
 ** ./src/constants/ShapeConstants.js
 **/